import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bool, func, shape } from "prop-types";
import Button from "pages/_components/Button";
import Drawer from "pages/_components/Drawer/Drawer";
import TableFrequentDestination from "pages/frequentDestination/_components/TableFrequentDestination";
import Avatar from "pages/_components/Avatar";
import { transferTypes } from "util/transfer";
import { isIOS } from "react-device-detect";
import GridTable from "pages/_components/GridTable/GridTable";
import { actions as contactActions } from "reducers/contactDestination";

const FORM_ID = "echeqs.emit";

const Beneficiaries = ({ isDesktop, values, setValues, setText, onChange }) => {
    const dispatch = useDispatch();
    const [openSidebarList, setOpenSidebarList] = useState(false);
    const [beneficiary, setBeneficiary] = useState({});
    const { cbuBlocked, fetching } = useSelector((state) => state.contactDestination);

    const selectBeneficiary = (beneficiary) => {
        if (beneficiary) {
            dispatch(
                contactActions.validateCbuBlocked({
                    creditCbu: beneficiary.cbu,
                }),
            );

            setBeneficiary(beneficiary);
            setOpenSidebarList(false);
        }
    };

    useEffect(() => {
        if (cbuBlocked === false) {
            // actualizo los datos solo si el beneficiario no es vacio
            if (setValues && Object.keys(beneficiary).length > 0) {
                setValues("frequentDestination", true);
                setValues("creditCbu", beneficiary.cbu);
                setValues("creditCuit", beneficiary.recipientDocumentNumber);
                setValues("nameRecipient", beneficiary.recipientName);
                setValues("email", beneficiary.recipientEmail);
                setValues("beneficiary", {
                    productType: beneficiary.productType,
                    localBank: beneficiary.localBank,
                    accountNumber: beneficiary.accountNumber,
                    recipientName: beneficiary.recipientName,
                    recipientDocumentType: beneficiary.recipientDocumentType,
                    recipientDocumentNumber: beneficiary.recipientDocumentNumber,
                    recipientEmail: beneficiary.recipientEmail,
                    cbu: beneficiary.cbu,
                    isOwn: beneficiary.isOwn,
                });
                setValues("transferKind", transferTypes[beneficiary.isOwn]);
                if (onChange) {
                    onChange({
                        frequentDestination: true,
                        creditCbu: beneficiary.cbu,
                        creditCuit: beneficiary.recipientDocumentNumber,
                        nameRecipient: beneficiary.recipientName,
                        email: beneficiary.recipientEmail,
                        beneficiary: {
                            productType: beneficiary.productType,
                            localBank: beneficiary.localBank,
                            accountNumber: beneficiary.accountNumber,
                            recipientName: beneficiary.recipientName,
                            recipientDocumentType: beneficiary.recipientDocumentType,
                            recipientDocumentNumber: beneficiary.recipientDocumentNumber,
                            recipientEmail: beneficiary.recipientEmail,
                            cbu: beneficiary.cbu,
                            isOwn: beneficiary.isOwn,
                        },
                        transferKind: transferTypes[beneficiary.isOwn],
                    });
                }
            }
        }
    }, [cbuBlocked]);

    const cleanBeneficiary = () => {
        if (setValues) {
            setValues("frequentDestination", false);
            setValues("creditCbu", "");
            setValues("creditCuit", "");
            setValues("nameRecipient", "");
            setValues("sendEmail", false);
            setValues("messageText", "");
            setValues("email", "");
            setValues("beneficiary", {
                productType: "",
                localBank: "",
                accountNumber: "",
                recipientName: "",
                recipientDocumentType: "",
                recipientDocumentNumber: "",
                recipientEmail: "",
                cbu: "",
                isOwn: "",
            });
            setValues("transferKind", "");
        }

        if (setText) {
            setText("");
        }
    };

    return (
        <>
            <div
                className="form-group hidden-label beneficiary-button"
                style={{
                    justifyContent: "flex-end",
                    height: "100%",
                    margin: 0,
                }}>
                <div
                    className="button-group"
                    style={{
                        marginBottom: "16px",
                    }}>
                    <Button
                        className="btn-outline"
                        label="echecks.search.contact"
                        onClick={() => setOpenSidebarList(true)}
                        loading={fetching}
                        disabled={!values.debitAccount || values.nameRecipient}
                    />
                </div>
            </div>
            {values.beneficiary.recipientName && (
                <GridTable.Container className={`beneficiary box border mb-4 ${isIOS ? "blocktagIos" : "blocktag"}`}>
                    <GridTable.Data columnStart={1} columnWidth={1}>
                        <Avatar
                            user={{
                                userFullName: values.beneficiary.recipientName,
                                defaultAvatarId: 0,
                                email: values.emailRecipient,
                            }}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={2} columnWidth={9} alignY="center">
                        <span>{`${values.nameRecipient}`}</span>
                    </GridTable.Data>
                    <GridTable.Data columnStart={12} columnWidth={1} className="close" alignX="center">
                        <Button onClick={() => cleanBeneficiary()} image="images/figma/icon/cross.svg" bsStyle="link" />
                    </GridTable.Data>
                </GridTable.Container>
            )}
            <Drawer openSidebar={openSidebarList} toggleSidebar={setOpenSidebarList}>
                <TableFrequentDestination
                    formId={FORM_ID}
                    onRowClick={selectBeneficiary}
                    searchClassName="d-flex flex-column"
                    isDesktop={isDesktop}
                    fromModal
                />
            </Drawer>
        </>
    );
};

Beneficiaries.propTypes = {
    isDesktop: bool.isRequired,
    setValues: func,
    onChange: func,
    values: shape({}),
    setText: func,
};

Beneficiaries.defaultProps = {
    setValues: null,
    values: {},
    setText: null,
    onChange: null,
};

export default Beneficiaries;
